/**
 * What an order-entry submit button should say, derived from the ticket's own state so the
 * button tells the user the next thing to do ("Enter size") or exactly what will be sent
 * ("Buy BTC-PERP") instead of a generic "Submit Order" that is merely greyed out.
 *
 * `null` means "no state-specific label" — the caller keeps its default text.
 */
export type SubmitLabel =
  | { kind: 'enterSize' }
  | { kind: 'side'; side: 'buy' | 'sell'; symbol: string }
  | null

export function resolveOrderSubmitLabel(input: {
  hasOrderRows: boolean
  hasAmount: boolean
  /** One instrument (possibly split across accounts) and every row on the same side. */
  isSingleSided: boolean
  side: 'buy' | 'sell'
  /** Display symbol of the single instrument (already formatted). */
  symbol: string | undefined
}): SubmitLabel {
  if (!input.hasOrderRows) return null
  if (!input.hasAmount) return { kind: 'enterSize' }
  if (input.isSingleSided && input.symbol) {
    return { kind: 'side', side: input.side, symbol: input.symbol }
  }
  return null
}
